import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy, faShare } from '@fortawesome/pro-light-svg-icons'

import { Button, Tools } from '@domain-group/suit-theme'

interface PendingOrderToolsProps {
  callbacks: {
    showBulkShareArtworksModal: VoidFunction,
    showGenerateCampaignScheduleModal: VoidFunction,
  },
  canGenerateSchedule? : boolean,
}

const PendingOrderTools = (props: PendingOrderToolsProps) => {
  const {
    callbacks: {
      showBulkShareArtworksModal,
      showGenerateCampaignScheduleModal,
    },
    canGenerateSchedule = true,
  } = props

  return (
    <Tools>
      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faShare} />}
        onClick={showBulkShareArtworksModal}
        size="medium"
      >
        Share Artworks
      </Button>

      {canGenerateSchedule && (
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faCopy} />}
          onClick={showGenerateCampaignScheduleModal}
          size="medium"
          //@ts-expect-error
          marginTop="medium"
        >
          Generate Schedule
        </Button>
      )}
    </Tools>
  )
}

export default PendingOrderTools
